module.exports = __webpack_public_path__ + "static/media/sell_start_service_teach_3.33201fc6.jpg";